import { render, staticRenderFns } from "./Base600Gray.vue?vue&type=template&id=99cf535c&scoped=true&"
var script = {}
import style0 from "./Base600Gray.vue?vue&type=style&index=0&id=99cf535c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cf535c",
  null
  
)

export default component.exports